import Vue from 'vue';

import VueRouter from 'vue-router';

import { gbwapsRoutes } from './gbwaps-routes';
import { trailingSlashGuard } from './trailing-slash';



Vue.use(VueRouter);



const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {

	return originalPush.call(this, location).catch((err) => err);

};



export default function createRouter() {

	const router = new VueRouter({

		mode: 'history',

		// 无斜杠路径与带斜杠路径分开匹配，避免 redirect 路由抢走 /download/ 的匹配
		strict: true,

		routes: gbwapsRoutes,

		scrollBehavior(to, from, savedPosition) {

			if (savedPosition) {

				return savedPosition;

			}

			return { x: 0, y: 0 };

		},

	});

	router.beforeEach(trailingSlashGuard);

	return router;

}

